import React from 'react';
import { __ } from '@wordpress/i18n';

// icons
import ArchiveIcon from '../../../../icons/ArchiveIcon';

/**
 * Section heading with an optional unread count badge and the toggle that
 * switches the list between the live feed and the archive.
 */
const SectionHeader = ({ title, count = 0, onToggleArchive, archiveActive = false, children }) => {
    return (
        <header className="commSection__header">
            <div className="commSection__headerRow">
                <h3 className="commSection__title">
                    {title}
                    {count > 0 && <span className="commBadge">{count}</span>}
                </h3>
                {onToggleArchive && (
                    <button
                        type="button"
                        className={`commSection__archiveToggle ${archiveActive ? 'is-active' : ''}`}
                        onClick={onToggleArchive}
                        title={archiveActive
                            ? __('Torna alle attività recenti', 'soundbetween')
                            : __('Mostra le attività archiviate', 'soundbetween')}>
                        <ArchiveIcon size={16}/>
                    </button>
                )}
            </div>
            {children}
        </header>
    )
}

export default SectionHeader;
